import React, { Component } from 'react';

import PropTypes from 'prop-types';

import AJAX from 'common/AJAX';
import parseAPIResponse, { isDefaultSuccessResponse } from 'common/util/parseAPIResponse';
import validateInput from 'common/validateInput';

import CustomPostFieldModal from './CustomPostFieldModal';

import 'css/components/modals/_CustomPostFieldModal.scss';

export default class EditCustomPostFieldModal extends Component {
  static propTypes = {
    defaultCustomPostField: PropTypes.object,
    onClose: PropTypes.func,
    onEdit: PropTypes.func,
  };

  state = {
    error: null,
    saving: false,
  };

  onEdit = async ({ name, options, type }) => {
    const { defaultCustomPostField, onEdit } = this.props;

    if (!validateInput.customPostField.name(name)) {
      this.setState({ error: 'Please enter a valid post field name (1-20 characters)' });
      return;
    }

    this.setState({ error: null, saving: true });
    const response = await AJAX.post('/api/customPostFields/edit', {
      customPostFieldID: defaultCustomPostField._id,
      customPostField: {
        name,
        options: options.length ? options : null,
      },
    });

    const { error } = parseAPIResponse(response, {
      isSuccessful: isDefaultSuccessResponse,
      errors: {
        'not authorized': `You don't have the permissions to edit a post field`,
        'no options': 'You should add at least one option',
        'plan does not support': 'Your plan does not support custom post fields',
        'too many options': `You should not add more than ${type.optionsLimit} options`,
      },
    });

    if (error) {
      this.setState({
        error: error.message,
        saving: false,
      });
      return;
    }

    this.setState({ saving: false }, () => onEdit());
  };

  render() {
    const { error, saving } = this.state;
    const { defaultCustomPostField, onClose } = this.props;

    return (
      <CustomPostFieldModal
        defaultCustomPostField={defaultCustomPostField}
        error={error}
        header="Edit Post Field"
        isTypeEditable={false}
        onClose={onClose}
        onSubmit={this.onEdit}
        saving={saving}
        submitLabel="Edit"
      />
    );
  }
}
